export default __webpack_public_path__ + "static/media/ajiChatbotIcon.d49c2c32.svg";